import './initLogger';
import { getSpmParams } from './spmParams';
import { IquicInfo } from './interface';

// 封装 iQuic 搭建组件埋点和监控上报方法
const { iTracker } = window;
const iTracert = {
  expoComponent(iquicInfo: IquicInfo, extInfo?: Record<string, any>) {
    try {
      const { spmId, spmTag, spmParams } = getSpmParams(iquicInfo);
      iTracker.expo(spmId, {
        ...spmTag,
        ...spmParams,
        ...extInfo,
      });
    } catch (err) {
      console.log(err);
    }
  },

  expoNode(
    iquicInfo: IquicInfo,
    nodeName: string,
    hasIndex?: boolean,
    extInfo?: Record<string, any>,
  ) {
    try {
      const { spmId, spmTag, spmParams } = getSpmParams(iquicInfo, nodeName);
      let nodeSpmId = spmId;
      if (hasIndex && 'index' in extInfo) {
        nodeSpmId = `${spmId}_${extInfo.index}`;
      }
      iTracker.expo(nodeSpmId, {
        ...spmTag,
        ...spmParams,
        ...extInfo,
      });
    } catch (err) {
      console.log(err);
    }
  },

  clickNode(
    iquicInfo: IquicInfo,
    nodeName: string,
    hasIndex?: boolean,
    extInfo?: Record<string, any>,
  ) {
    try {
      const { spmId, spmTag, spmParams } = getSpmParams(iquicInfo, nodeName);
      let nodeSpmId = spmId;
      if (hasIndex && 'index' in extInfo) {
        nodeSpmId = `${spmId}_${extInfo.index}`;
      }
      iTracker.click(nodeSpmId, {
        ...spmTag,
        ...spmParams,
        ...extInfo,
      });
    } catch (err) {
      console.log(err);
    }
  },
};

// 提供全局变量供页面组件上报埋点
Object.defineProperty(window, 'iTracert', {
  value: iTracert,
  writable: false,
  configurable: false,
});
